import $ from "jquery";
import React, { Component } from "react";
import RefundService from "../state/payment/refund/RefundService";
import PaymentRefundModal from './components/PaymentRefundModal/PaymentRefundModal';
import RefundConfirmationModal from "./components/RefundConfirmationModal/RefundConfirmationModal";
import EditCreditMemoModal from "./editcreditmemomodal.component.jsx";
const uuidv4 = require("uuid/v4")

const REFUND_MODAL_ID = "payment-refund-modal-" + uuidv4()

class EditAndRefundCreditMemoModal extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            creditMemoId: this.props.creditMemoId || null,
            contactId: this.props.contactId || null,
            refundModal: false,
            refundConfirmationModal: false,
            refundResponse: null,
            remainingAmount: '',
            customerAccount: '',
            identifier: '',
            currency: '',
            readOnly: this.props.readOnly || false,
            hideDeleteButton: this.props.hideDeleteButton || false,
        }
        this.closeModal = this.closeModal.bind(this)
        this.showRefundModal = this.showRefundModal.bind(this)
        this.handleRefund = this.handleRefund.bind(this)
    }

    closeModal(objectId, objectType) {
        this.props.onClose(objectId, objectType)
    }

    showRefundModal(identifier, currency, remainingAmount) {
        this.setState({
            identifier: identifier,
            currency: currency,
            remainingAmount: remainingAmount,
            refundModal: true,
        })
    }

    async handleRefund(_, payload) {
        const res = await RefundService.processCreditMemoRefund(this.state.creditMemoId, payload)
        $("#" + REFUND_MODAL_ID).modal("hide")
        this.setState({
            refundModal: false,
            refundConfirmationModal: true,
            refundResponse: res,
        })
    }

    getRefundModal() {
        return <PaymentRefundModal
            id={REFUND_MODAL_ID}
            onClose={() => this.setState({ refundModal: false })}
            onRefund={this.handleRefund}
            creditMemoId={this.state.creditMemoId}
        />
    }

    render() {
        if (this.state.refundModal) {
            return this.getRefundModal()
        }

        if (this.state.refundConfirmationModal) {
            return (
                <RefundConfirmationModal
                    refundResponse={this.state.refundResponse}
                    creditMemoId={this.state.creditMemoId}
                    onClose={() => this.setState({ refundConfirmationModal: false })}
                />
            )
        }

        return (
            <EditCreditMemoModal
                contactId={this.state.contactId}
                creditMemoId={this.state.creditMemoId}
                onClose={this.closeModal}
                onCloseForRefund={this.showRefundModal}
                readOnly={this.props.readOnly}
                onRefresh={this.props.onRefresh}
                hideDeleteButton={this.props.hideDeleteButton}
            />
        )
    }
}

export default EditAndRefundCreditMemoModal


// WEBPACK FOOTER //
// ./src/invoice/editandrefundcreditmemomodal.component.jsx